export const NFTControllerTEST = "0x5FbDB2315678afecb367f032d93F642f64180aa3";
export const ERC20TEST = "0xe7f1725E7734CE288F8367e1Bb143E90bb3F0512";

const toHex = (value) => `0x${value.toString(16)}`;

export const CHAIN_ID = {
  MAINNET: 1,
  BSC: 56,
  BSCTest: 97,
  XDAI: 100,
  POLYGON: 137,
  HARDHAT: 31337,
  POLYGONMUMBAI: 80001,
};

export const networks = {
  [CHAIN_ID.MAINNET]: {
    chainName: "MAINNET",
    BEP20S: [
      {
        address: "0x0000000000000000000000000000000000000000",
        symbol: "ETH",
      },
      {
        address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        symbol: "USDT",
      },
    ],
    chainId: toHex(CHAIN_ID.MAINNET),
    // rpcUrls: ["https://rpc.xdaichain.com"],
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: 18,
    },
    blockExplorerUrls: ["https://etherscan.io"],
  },
  [CHAIN_ID.BSC]: {
    chainName: "Binance Smart Chain",
    NFTController: "0x390dE02d8e557DB2a9ef3B4B9C65D2BEF17611D2",
    BEP20S: [
      {
        address: "0x0000000000000000000000000000000000000000",
        symbol: "BNB",
      },
      {
        address: "0x55d398326f99059fF775485246999027B3197955",
        symbol: "USDT",
      },
      {
        address: "0x92bD46E88931cbcfCFe1a4b7cCE1847D6fA74FAD",
        symbol: "AZTLAN",
      },
      {
        address: "0x5ed263e76C3435304F8e93bE90EC963be3c7Cdd3",
        symbol: "LVA",
      },
      { address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c", symbol: "WBNB" },
      {
        address: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
        symbol: "BUSD",
      },
      {
        address: "0x3EE2200Efb3400fAbB9AacF31297cBdD1d435D47",
        symbol: "ADA",
      },
    ],
    chainId: toHex(CHAIN_ID.BSC),
    nativeCurrency: {
      name: "BNB",
      symbol: "BNB",
      decimals: 18,
    },
    rpcUrls: ["https://bsc-dataseed.binance.org/"],
    blockExplorerUrls: ["https://bscscan.com/"],
  },
  [CHAIN_ID.BSCTest]: {
    chainName: "BSCTESTNET",
    // NFTController: "0x0eF651C95016A0051A4e3caC59e4913A7B70363f",
    BEP20S: [
      {
        address: "0x0000000000000000000000000000000000000000",
        symbol: "BNB",
      },
      {
        address: "0x337610d27c682E347C9cD60BD4b3b107C9d34dDd",
        symbol: "USDT",
      },
      {
        address: "0xeA161e15d5d69b1b3E569Ce03C51Caa800b4e272",
        symbol: "AZTLAN",
      },
    ],
    chainId: toHex(CHAIN_ID.BSCTest),
    rpcUrls: ["https://data-seed-prebsc-1-s1.binance.org:8545/"],
    nativeCurrency: {
      name: "BNB",
      symbol: "BNB",
      decimals: 18,
    },
    blockExplorerUrls: ["https://testnet.bscscan.com/"],
    faucet: "https://testnet.binance.org/faucet-smart",
  },
  [CHAIN_ID.XDAI]: {
    chainName: "xDAI Chain",
    BEP20S: [
      {
        address: "0x0000000000000000000000000000000000000000",
        symbol: "xDAI",
      },
      {
        address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        symbol: "USDT",
      },
      {
        address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        symbol: "AZTLAN",
      },
    ],
    chainId: toHex(CHAIN_ID.XDAI),
    rpcUrls: ["https://rpc.xdaichain.com"],
    nativeCurrency: {
      name: "xDAI",
      symbol: "xDAI",
      decimals: 18,
    },
    blockExplorerUrls: ["https://blockscout.com/xdai/mainnet"],
  },
  [CHAIN_ID.POLYGON]: {
    chainName: "Polygon",
    NFTController: "0x98c186b7b64FFEEc733081e94c29cE4E9aa09800",
    BEP20S: [
      {
        address: "0x0000000000000000000000000000000000000000",
        symbol: "MATIC",
      },
      {
        address: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
        symbol: "USDT",
      },
    ],
    chainId: toHex(CHAIN_ID.POLYGON),
    nativeCurrency: {
      name: "MATIC",
      symbol: "MATIC",
      decimals: 18,
    },
    rpcUrls: ["https://rpc-mainnet.matic.network/"],
    blockExplorerUrls: ["https://polygonscan.com/"],
  },
  [CHAIN_ID.HARDHAT]: {
    chainName: "HARDHAT",
    NFTController: NFTControllerTEST,
    BEP20S: [
      {
        address: "0x0000000000000000000000000000000000000000",
        symbol: "ETH",
      },
      {
        address: ERC20TEST,
        symbol: "USDT",
        decimals: 18,
      },
      {
        address: ERC20TEST,
        symbol: "AZTLAN",
        decimals: 18,
      },
    ],
    chainId: toHex(CHAIN_ID.HARDHAT),
    rpcUrls: ["http://localhost:8545/"],
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: 18,
    },
    blockExplorerUrls: ["https://testnet.bscscan.com/"],
  },
  [CHAIN_ID.POLYGONMUMBAI]: {
    chainName: "MUMBAI",
    NFTController: "0x7c825fF7436A016212F291B6c9A96746DDdf58E8",
    BEP20S: [
      {
        address: "0x0000000000000000000000000000000000000000",
        symbol: "MATIC",
      },
      {
        address: "0x7b6b4448c3336f724ddc84e2da3a1c74878beeee",
        symbol: "USDT",
      },
      {
        address: "0x3359F156e05C10E5b236e1B9dDFc2B1eE50ae8a6",
        symbol: "AZTLAN",
        decimals: 18,
      },
    ],
    chainId: toHex(CHAIN_ID.POLYGONMUMBAI),
    rpcUrls: ["https://matic-mumbai.chainstacklabs.com/"],
    nativeCurrency: {
      name: "MATIC",
      symbol: "MATIC",
      decimals: 18,
    },
    blockExplorerUrls: ["https://mumbai.polygonscan.com/"],
    faucet: "https://faucet.polygon.technology",
  },
};

export const fillColor = "#ccc";

export const primaryColor = "#0b6dff";

export const galleryFilters = ["digital_art", "photography"];

export const developers = [
  {
    linkedin: "in/arturo-underwood",
    name: "Arturo Underwood",
    roles: ["Founder"],
    picture: "https://i.imgur.com/jd0LwoH.png",
  },
  {
    linkedin: "in/diego-velazquez-rabasa",
    name: "Diego Velazquez",
    roles: ["Co-founder", "Product Designer"],
    picture:
      "https://yt3.ggpht.com/ytc/AKedOLTTrTKLWwFTvhcGvnfZ2cUHazsN8gSI4xDGHhcbtw=s176-c-k-c0x00ffffff-no-rj",
  },
  {
    linkedin: "in/cristian-palacios-beltran",
    name: "Cristian Palacios",
    roles: ["Co-founder", "Full Stack Engineer"],
    picture:
      "https://media-exp1.licdn.com/dms/image/C5603AQHHMk6YY1NDtQ/profile-displayphoto-shrink_800_800/0/1623793196901?e=1637193600&v=beta&t=BIiui_0fbXUDi8nfTe296iJ_DZoxT_zruUDGXCog4dY",
  },
];

export const tokenomicsDistribution = [
  { label: "founders", usage: 10, symbol: "*" },
  { label: "parters", usage: 10 },
  { label: "marketing", usage: 5 },
  { label: "airdrop", usage: 5 },
  { label: "reserve", usage: 5 },
  { label: "sale", usage: 60 },
];

export const tokenStats = {
  totalSupply: "100000000000000000000000000",
  ticker: "AZTLAN",
  type: "ERC20",
  address: "0x0DCd1Bf9A1b36cE34237eEaFef220932846BCD82",
};

export const contactPhone = "52-12-12-12-12";

export const contactEmail = "contacto@aztlan.market";

export const profileInputs = [
  // "username",
  // "description",
  // "email",
  // "twitter",
  // "facebook",
  // "instagram",
  // "website",
  // "other",
  { inputName: "username", col: 6 },
  { inputName: "email", col: 6 },
  { inputName: "description", col: 12, inputType: "textarea" },
  { inputName: "twitter", col: 6 },
  { inputName: "facebook", col: 6 },
  { inputName: "instagram", col: 6 },
  { inputName: "website", col: 6 },
  { inputName: "other", col: 6 },
];

export const categoryTags = [
  "Art",
  "Music",
  "Games",
  "Collectibles",
  // "Photography",
  // "Sports",
  // "Metaverses",
  // "DeFi",
  // "Memes",
];

export const connectors = {
  metamask: {
    title: "Metamask",
    description: "A crypto wallet and gateway to blockchain apps",
    image: "/img/wallets/metamask.svg",
  },
  bsc: {
    title: "BSC",
    description: "A Chrome extension wallet that supports Binance Smart Chain",
    image: "/img/wallets/bsc.svg",
  },
  torus: {
    title: "Torus",
    description: "Create or connect a wallet with Google, Facebook, etc",
    image: "/img/wallets/torus-alternative.webp",
  },
  local: {
    title: "Internal",
    description: "Store keys in your local storage (Not recommended)",
    image: "/img/wallets/navigator.png",
  },
};

export const WALLETS = {
  BSC: "BSC",
  METAMASK: "METAMASK",
  TORUS: "TORUS",
};
